import * as React from "react";
const SvgLessThan = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5 17.5 9.25 12l8.25-5.5-1-1.5L6 12l10.5 7z",
  fillRule: "evenodd",
  fill: "currentColor"
}));
export default SvgLessThan;